export const ONLY_LOOKING_FOR_QUOTES_TEXT =
  "The product is not ready/I was only looking for quotes at this time";

export const BOOKED_OFF_PLATFORM_TEXT = "Shipment booked off platform";

export const OTHER_REASON_OPTION = "other";
